import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function arqueacaoautomatica(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@arqueacaoautomatica/FIND_ARQUEACAOAUTO':
      case '@arqueacaoautomatica/UPDATE_ARQUEACAOAUTO':
      case '@arqueacaoautomatica/DELETE_ARQUEACAOAUTO':
      case '@arqueacaoautomatica/STORE_ARQUEACAOAUTO':
      case '@arqueacaoautomatica/ARQUEACAOAUTO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@arqueacaoautomatica/SUCCESS_REMOVE':
      case '@arqueacaoautomatica/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@arqueacaoautomatica/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.arqueacoes;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@arqueacaoautomatica/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.arqueacao;
        break;
      }

      case '@arqueacaoautomatica/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
